import { Alert } from '@/shared/ui/Alert'

import { useLevelContext } from '../../../context'

export const DigitalProductJourneyLevelPlayChallengeFooterWrongAnswerAlert =
  () => {
    const { answerIsWrong, hearts, journeyAllowWrongAnswers } =
      useLevelContext()
    let heartsLeftMessage = ''
    if (hearts >= 5)
      heartsLeftMessage = `Você tem ${hearts} corações restantes, tente novamente.`
    else if (hearts > 3)
      heartsLeftMessage = `Ainda restam ${hearts} corações. Continue com atenção.`
    else if (hearts == 3)
      heartsLeftMessage = `Fique atento, só restam ${hearts} corações. Foco!`
    else if (hearts == 2)
      heartsLeftMessage = `Apenas ${hearts} corações restantes. Muito cuidado 🥶`
    else if (hearts == 1)
      heartsLeftMessage = `Último coração. Respire fundo e concentre-se no desafio.`
    else
      heartsLeftMessage = `Game over. Tente novamente e aprimore suas habilidades.`

    if (!answerIsWrong) return null
    return (
      <div className="pointer-events-none absolute left-0 w-full bottom-0 rounded-b-xl px-6 pt-6 md:pt-8 md:px-8 pb-20">
        <Alert
          className="pointer-events-auto"
          variant="danger"
          icon="circle-xmark"
          title="Resposta incorreta"
          subtitle={!journeyAllowWrongAnswers ? heartsLeftMessage : undefined}
        />
      </div>
    )
  }
